import { Badge } from "@loot-os/ui/components/badge";

/** Order lifecycle: shipped or done = primary, cancelled or failed = destructive, waiting = secondary. */
export function OrderStatusBadge({ status }: { status: string }) {
  const variant =
    status === "SHIPPED" || status === "SUCCESS"
      ? "default"
      : status === "CANCELLED" || status === "FAIL"
        ? "destructive"
        : status === "HOLD" || status === "UNAPPROVED"
          ? "secondary"
          : "outline";
  return <Badge variant={variant}>{status.toLowerCase().replace("_", " ")}</Badge>;
}
